<template>
  <div>
    <v-select
      v-model="locale"
      :label="$t('a')"
      :items="items"
      item-text="text"
      item-value="value"
      outlined
      dense
    >
      <template v-slot:selection="{ item }">
        <img :src="item.flag" height="13px" class="mr-2"/>
        <span>{{ item.text }}</span>
      </template>
      <template v-slot:item="{ item }">
        <img :src="item.flag" height="13px" class="mr-2"/>
        <span>{{ item.text }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vuei18n from '@/i18n'

export default {
  data: () => ({
    locale: null,
    items: [
      { text: 'Français', value: 'fr', flag: require('@/assets/app/images/flag_fr.png') },
      { text: 'English', value: 'en', flag: require('@/assets/app/images/flag_en.png') },
    ],
  }),
  mounted() {
    this.locale = this.user.data.locale || 'fr'
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  },
  watch: {
    locale: {
      handler(val, oldVal) {
        if (val && oldVal) {
          this.$functions.httpsCallable('updateUser')({
            locale: this.locale
          })
          vuei18n.locale = this.locale
        }
      }
    }
  }
}
</script>

<i18n>
{
  "fr": {
    "a": "Langue du site internet"
  },
  "en": {
    "a": "Website language"
  }
}
</i18n>